import { type Event } from '@kalos/kalos-rpc';
import groupBy from 'lodash/groupBy';

import { effectiveEventTradeId } from '../../../utils/eventTrade';
import {
  TRADE_TAB_DEPARTMENT_CODE,
  TRADE_TAB_LABEL,
  TRADE_TAB_ORDER,
} from '../../ComponentsLibrary/FirstCalls/firstCallsTradeTabs';

export const getJobTypeBreakdown = (calls: Event[]) => {
  const grouped = groupBy(calls, 'jobType');
  return Object.entries(grouped).map(([jobType, calls]) => ({
    jobType: jobType || 'Unspecified',
    count: calls.length,
  }));
};

/** Trade filter options in display order (HVAC, Plumbing, Electrical); keys are trade ids. */
export const TRADE_FILTER_OPTIONS: [string, string][] = TRADE_TAB_ORDER.map((tab) => [
  String(TRADE_TAB_DEPARTMENT_CODE[tab]),
  TRADE_TAB_LABEL[tab],
]);

/** Empty selection matches every call; otherwise the call's effective trade (as Dispatch and First Calls read it) must be picked. */
export const matchesTradeFilter = (
  call: Pick<Event, 'eventTradeId' | 'departmentId'>,
  tradeIds: string[],
) => !tradeIds.length || tradeIds.includes(String(effectiveEventTradeId(call)));
